import type { Key, ReactNode } from "react";
import { Flex, H5 } from "orcs-design-system";

type FieldLabelProps = {
  children?: ReactNode;
};

export const FieldLabel = ({ children }: FieldLabelProps) => (
  <H5
    sizing="small"
    weight="bold"
    color="subText"
    uppercase
    letterSpacing="0.04em"
  >
    {children}
  </H5>
);

type FieldStackProps = {
  children?: ReactNode;
  "data-testid"?: string;
  /**
   * No wrapper. Children become cells of a parent Grid with
   * gridTemplateColumns="max-content 1fr".
   */
  horizontal?: boolean;
  /** React list identity when FieldStack is the element returned from a map. */
  key?: Key;
};

export const FieldStack = ({
  children,
  "data-testid": dataTestId,
  horizontal = false,
}: FieldStackProps) =>
  horizontal ? (
    children
  ) : (
    <Flex flexDirection="column" gap="xs" data-testid={dataTestId}>
      {children}
    </Flex>
  );
